import { InputControl } from "@arangodb/ui";
import { Grid } from "@chakra-ui/react";
import React from "react";
import { useAnalyzersContext } from "../../AnalyzersContext";

export const ClassificationConfig = ({
  basePropertiesPath
}: {
  basePropertiesPath: string;
}) => {
  const { isFormDisabled: isDisabled } = useAnalyzersContext();
  return (
    <Grid templateColumns={"1fr 1fr 1fr"} columnGap="4" rowGap="4">
      <InputControl
        isDisabled={isDisabled}
        name={`${basePropertiesPath}.model_location`}
        label="Model Location"
      />
      <InputControl
        isDisabled={isDisabled}
        inputProps={{
          type: "number"
        }}
        name={`${basePropertiesPath}.top_k`}
        label="Top K"
      />
      <InputControl
        isDisabled={isDisabled}
        inputProps={{
          type: "number"
        }}
        name={`${basePropertiesPath}.threshold`}
        label="Threshold"
      />
    </Grid>
  );
};
